module.exports = __webpack_public_path__ + "img/sent-plane.297543ea.png";